import { lazy } from 'react';
import { Route } from 'react-router-dom';

const SpinningWheel = lazy(() => import('../components/spinningWheel/index'));
const SpinTheWheel = lazy(() => import('../components/spinTheWheel'));
const SpinWheelGameWebview = lazy(() => import('../components/spin-wheel-game-webview'));
const CricketGame = lazy(() => import('../components/cricket-game'));
const IplSuperChallenge = lazy(() => import('../components/ipl-super-challenge'));

const gamificationRoutes = (
	<>
		<Route path="/spinning-wheel" element={<SpinningWheel />} />
		<Route path="/spin-the-wheel" element={<SpinTheWheel />} />
		<Route path="/spin-wheel-game" element={<SpinWheelGameWebview />} />
		<Route path="/cricket-game" element={<CricketGame />} />
		<Route path="/ipl-super-challenge" element={<IplSuperChallenge />} />
	</>
);

export default gamificationRoutes;
